// NOTE: Footer 앱다운 버튼
import push from '@/utils/gaEvents/push'

const onClickAppDownButton = (pageUrl: string) => {
  push({
    event: 'appDownload',
    page: pageUrl
  } satisfies GtagAppDownEvent)
}

const appDownEvent = {
  onClickAppDownButton
}

export default appDownEvent
